import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ModalsKeys } from '~/types/uiTypes';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type ModalsType = { [key in ModalsKeys]: boolean };

type FooterDisplayType = 'show' | 'hide';
type uiState = {
  modals: Partial<ModalsType>;
  footerDisplay: FooterDisplayType;
};

const initialState: uiState = {
  modals: {},
  footerDisplay: 'show',
};

const uiStateSlice = createSlice({
  name: 'ui-state',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalsKeys>) => {
      return { ...state, modals: { ...state.modals, [action.payload]: true } };
    },
    closeModal: (state, action: PayloadAction<ModalsKeys>) => {
      return { ...state, modals: { ...state.modals, [action.payload]: false } };
    },
    setFooterDisplay: (state, action: PayloadAction<FooterDisplayType>) => {
      return {
        ...state,
        footerDisplay: action.payload,
      };
    },
  },
});

export const { openModal, closeModal, setFooterDisplay } = uiStateSlice.actions;

export default uiStateSlice.reducer;
